import React, { memo } from "react";
import { MapContainer } from "./styled";
import PT from "prop-types";
import Info from "_c/atoms/Info";
import { useHistory } from "react-router-dom";
import { SALOON_NS as ns } from "@/i18n/ns";
import AsideMap from "_c/modules/profile/common/AsideMap";
import { analyticsAction } from "@/utils/analytics";

const Map = ({ coords, isOwner, isPremium, saloonId, locale, t }) => {
  const history = useHistory();
  const hasCoords = coords && coords[0] !== 0 && coords[1] !== 0;
  const onLocationChange = () => {
    analyticsAction({
      category: "salon_profile",
      action: "salon_set_address",
    });
    history.push("/salon/dashboard/common");
  };
  return (
    <MapContainer>
      {hasCoords ? (
        <AsideMap
          id={saloonId}
          isPremium={isPremium}
          coords={coords}
          t={t}
          locale={locale}
        />
      ) : (
        <Info
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            margin: 0,
          }}
        >
          {isOwner ? (
            <span>
              <button onClick={onLocationChange}>
                {t(`${ns}:aside.location_set_link`)}
              </button>
            </span>
          ) : (
            t(`${ns}:aside.location_empty`)
          )}
        </Info>
      )}
    </MapContainer>
  );
};
Map.displayName = "MasterAsideMap";
Map.propTypes = {
  coords: PT.array,
  isOwner: PT.bool,
  isPremium: PT.bool,
  saloonId: PT.string,
};
export default memo(Map);
